import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const LazyLoadImg = ({ src, className }) => (
  <LazyLoadImage
    alt={''}
    height={''}
    src={src} // use normal <img> attributes as props
    width={''} 
    className={className}
  />
);

export default LazyLoadImg;